import CardDiv from "modules/common/card-div/CardDiv";
import React from "react";
import TimeOffCanvas from "./TimeOffCanvas";
import { timeArray } from "modules/utilities/utility";

function TimeSelector({ date }) {
  return (
    <div className="d-flex gap-3 flex-wrap py-5">
      {timeArray.map((time) => {
        return (
          <div>
            <TimeOffCanvas name={time} date={date} />
          </div>
        );
      })}
    </div>
  );
}

export default TimeSelector;
